import base from '../base/base';
import header from '../base/header';

import TopVideoPlayer from '../../components/platformPlayer/TopVideoPlayer';
import LazyloadVideo from '../../components/platformPlayer/LazyloadVideo';
import TrackingUtils from '../../components/fsUtils/TrackingUtils';
import CollectionsNav from '../../components/collections-nav/CollectionsNav';


new TopVideoPlayer();
new CollectionsNav();

let shareLinks = document.querySelectorAll('.trending-item-share-link');
if(typeof base.analytics !== 'undefined' && (shareLinks && shareLinks.length > 0) ) {
	const pageType = base.analytics.getPageMeta()['page_type'];
	const utmTerm = (pageType == 'home') ? 'homepage' : (pageType == 'section front') ? 'sf' : 'post';

	TrackingUtils.setLinkTracking(shareLinks,'parsely',{
	    'utm_campaign'  : 'share_buttons',
	    'utm_source'    : 'share_fb',
	    'utm_medium'    : 'fscom',
	    'utm_content'   : 'original_share',
	    'utm_term'		: utmTerm
	});	
}



// WEBPACK FOOTER //
// ./assets/layouts/section-front/section-front.js